class MessageParser {
  constructor(actionProvider) {
    this.actionProvider = actionProvider;
  }

  parse(message) {
    console.log(message);
    const lowercase = message.toLowerCase();

    if (
      lowercase.includes("hello") ||
      lowercase.includes("hi") ||
      lowercase.includes("hii") ||
      lowercase.includes("hiii")
    ) {
      this.actionProvider.greet();
    }

    if (
      lowercase.includes("mail") ||
      lowercase.includes("can i get mail id") ||
      lowercase.includes("can i get email id") ||
      lowercase.includes("can i get email") ||
      lowercase.includes("can i get mail") ||
      lowercase.includes("can i get mail") ||
      lowercase.includes("mail") ||
      lowercase.includes("emailId")
    ) {
      this.actionProvider.mailFunc();
    }

    if (
      lowercase.includes("mobile") ||
      lowercase.includes("mobile no") ||
      lowercase.includes("can i get a contact no") ||
      lowercase.includes("mobile no") ||
      lowercase.includes("mobile") ||
      lowercase.includes("can i get a contact no") ||
      lowercase.includes("can i get customer care no") ||
      lowercase.includes("can i get a mobile no") ||
      lowercase.includes("can i get a mobile") ||
      lowercase.includes("please share contact no") ||
      lowercase.includes("share a mobile no") ||
      lowercase.includes("share a contact no") ||
      lowercase.includes("share a contact number") ||
      lowercase.includes("share a mobile number") ||
      lowercase.includes("can i get mobile number") ||
      lowercase.includes("can i get contact number")
    ) {
      this.actionProvider.mobileFunc();
    }

    if (
      lowercase.includes("support") ||
      lowercase.includes("how to get support") ||
      lowercase.includes("how to get help") ||
      lowercase.includes("where to get help")
    ) {
      this.actionProvider.handleSupportOption();
    }
    if (
      lowercase.includes("contact") ||
      lowercase.includes("how to contact") ||
      lowercase.includes("how i can contact") ||
      lowercase.includes("where i can discuss")
    ) {
      this.actionProvider.handleContactOption();
    }
    if (
      lowercase.includes("pricing") ||
      lowercase.includes("what are the pricing") ||
      lowercase.includes("what is the pricing") ||
      lowercase.includes("what is the cost")
    ) {
      this.actionProvider.handlePricingOption();
    }
  }
}

export default MessageParser;
